export default __webpack_public_path__ + "static/media/clock.854e06b1.svg";